<template>
  <div></div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageForm from '../index/mixins/page_bm_form';

  export default {
    mixins: [IndexCommon, MobileCommon, PageForm],
    components: {},
    data() {
      return {}
    },
    async created() {
      // 空路由，过渡页面，跳转到这个表示开始 [填写/修改] 报名信息
      console.log('-> 进入[填写/修改]报名信息路由');

      // 已经自动跳转了一次，目的是为了返回上一步时不出Bug
      let autoPushStep = sessionStorage.getItem('autoPushStep');
      if (autoPushStep) {
        console.warn('-> 已经自动跳转过一次页面了，强制返回前一个路由');
        sessionStorage.removeItem('autoPushStep');
        this.$router.go(-1);
      } else {
        // 清除上一次sessionStorage中的formData，防止Bug
        sessionStorage.removeItem('signupMobileForm');
        this.initFormStart();
      }
    },
    methods: {
      async initFormStart() {
        let { studentSignupId, idCard, signupNoticeId } = this.$route.query;

        //* ** 情况一：参数接收到已报名的预约号(studentSignupId)和身份证(idCard) 【修改一个报名信息】
        if (studentSignupId && idCard) {
          // 根据报名预约号查询报名信息 #李茹钰/2019-03-14#
          let { data } = await this.$ajax.gateway('/bm/IStudentSignupApi_studentApply', { studentSignupId, idCard });
          if (data.code === 200) {
            data = data.data;
            console.log('[-> BmForm] [修改] 一个报名信息 [go to new router]', data);
            data = this.formatFormData(data);
            console.log('[-> BmForm] [修改] 一个报名信息 [back]', data);
            // 回显数据
            this.initFormData(data);
            // 跳转路由
            this.nextStepRouter('edit');
          } else {
            //* ** 情况三：异常
            console.error('-> 根据报名预约号查询报名信息异常，返回登录校验页面');
            this.$router.push({ path: 'bm_login', query: { signupNoticeId } })
          }
          //* ** 情况二：参数接收到报名活动的ID(signupNoticeId)，并且通过了前一步的校验(能获取到sessionStorage) 【新增一个报名信息】
        } else {
          try {
            let signupForm = JSON.parse(sessionStorage.getItem('signupForm'));
            if (signupForm && signupNoticeId) {
              console.log('[-> BmForm] [新增] 一个报名信息 [go to new router]', signupForm);
              // 回显数据
              this.initFormData(signupForm);
              // 跳转路由
              this.nextStepRouter('add');
            } else {
              //* ** 情况三：异常
              console.error('-> 参数或缓存数据异常，返回登录校验页面');
              this.$router.push({ path: 'bm_login', query: { signupNoticeId } })
            }
          } catch (e) {
            //* ** 情况三：异常
            console.error('-> 缓存的校验数据异常，返回登录校验页面');
            this.$router.push({ path: 'bm_login', query: { signupNoticeId } })
          }
        }
      },
      initFormData(obj) {
        // obj
        console.log('[-> BmForm] initFormData', obj);
        sessionStorage.setItem('signupMobileForm', JSON.stringify(obj));
      },
      nextStepRouter(type) {
        sessionStorage.setItem('autoPushStep', '1');
        // 开始进入报名流程 type = 'add'/'edit'
        if (this.studentType === 1) {
          // 幼儿园::第一步流程::上传照片
          this.$router.push({ path: 'step1_upload_pic', query: this.$route.query })
        } else {
          // 中小学::第一步流程::学生信息
          this.$router.push({ path: 'step2_student_info', query: this.$route.query })
        }
      }
    }
  }
</script>
